import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { AccessConfig, AccessState } from 'src/app/core/schemas/subscription-plan.schema';
import { SubscriptionPlanAccessService } from 'src/app/core/services/subscription-plan-access.service';

@Directive({
  selector: '[csiSubscriptionPlanAccessControlStructural]'
})

/**
 * Currently does not support matTooltip
 */
export class SubscriptionPlanAccessControlStructuralDirective implements OnInit, OnDestroy {
  @Input('csiSubscriptionPlanAccessControlStructural') key!: string;

  private accessConfig: AccessConfig;

  constructor(
    private templateRef: TemplateRef<any>,
    private vc: ViewContainerRef,
    private subscriptionPlanAccessService: SubscriptionPlanAccessService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.accessConfig = this.subscriptionPlanAccessService.flattenedSubscriptionPlanSchema[
      this.key
    ] || { accessState: AccessState.ENABLED };
    this.renderView();
  }

  ngOnDestroy() {}

  private renderView() {
    // Clearing the view container may delay child component creation to a later change detection cycle.
    this.vc.clear();

    switch (this.accessConfig.accessState) {
      case AccessState.HIDDEN:
        // Hidden in case is misleading, as rather than being hidden the component does not exist.
        return;

      default:
        // Render normally
        const view = this.vc.createEmbeddedView(this.templateRef);

        Promise.resolve().then(() => {
          const rootNodes = view.rootNodes;

          rootNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              this.applyStateToElement(node);
            }
          });
        });
    }
  }

  private applyStateToElement(el: HTMLElement) {
    switch (this.accessConfig.accessState) {
      case AccessState.DISABLED:
        this.subscriptionPlanAccessService.applyDisabledStyles(el, this.renderer);
        break;

      case AccessState.PRO_LOCKED:
        this.subscriptionPlanAccessService.applyDisabledStyles(el, this.renderer);
        this.subscriptionPlanAccessService.addLockedBadge(
          this.key,
          el,
          this.renderer,
          document,
          'PRO'
        );
        this.subscriptionPlanAccessService.addInteractionBlocker(el, this.renderer);
        break;

      case AccessState.ADD_ON_LOCKED:
        this.subscriptionPlanAccessService.applyDisabledStyles(el, this.renderer);
        this.subscriptionPlanAccessService.addLockedBadge(
          this.key,
          el,
          this.renderer,
          document,
          'ADD ON'
        );
        this.subscriptionPlanAccessService.addInteractionBlocker(el, this.renderer);
        break;

      case AccessState.PRO_OR_ADD_ON_LOCKED:
        this.subscriptionPlanAccessService.applyDisabledStyles(el, this.renderer);
        this.subscriptionPlanAccessService.addLockedBadge(
          this.key,
          el,
          this.renderer,
          document,
          'PRO / ADD ON'
        );
        this.subscriptionPlanAccessService.addInteractionBlocker(el, this.renderer);
        break;

      case AccessState.ENABLED:
        this.subscriptionPlanAccessService.clearDisabledStyles(el, this.renderer);
        this.subscriptionPlanAccessService.removeInteractionBlocker(el, this.renderer);
      default:
        break;
    }
  }
}
